import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "root-worker-status" };
const _hoisted_2 = ["data-cy", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendCodeList, (filterId, key) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-cy": `attend-code-${filterId}`,
                key: key,
                class: _normalizeClass(_ctx.getLabelClass(filterId)),
                onClick: ($event) => (_ctx.handleClickFilter(filterId))
            }, [
                _createElementVNode("span", {
                    class: _normalizeClass(`label-name label-name--${filterId.toLowerCase()}`)
                }, _toDisplayString(_ctx.$t(_ctx.mapControlAttendCode[filterId].text)), 3 /* TEXT, CLASS */),
                _createTextVNode(" " + _toDisplayString(_ctx.workerTotal[filterId.toLowerCase()]), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_2));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
